import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import DvdDetailsComponent from 'components/DvdDetails';
import StatisticSideBar from 'components/StatisticSideBar';

import Loader from 'components/ui/Loader';

import { getDvdDetails } from './dvdsSlice';

const DvdsDetails = () => {
  const [searchParams] = useSearchParams();
  const { dvdId } = useParams();
  const international = searchParams.get('international');

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getDvdDetails({ dvdId }));
  }, [dispatch, dvdId, international]);

  const dvdDetails = useSelector((state: RootState) => state.dvds.dvdDetails);

  return dvdDetails ? (
      <Layout sidebar={(
        <div>
          <StatisticSideBar
            context="album"
            charts={dvdDetails.charts}
            sells={dvdDetails.statistics?.albumSells}
          />
        </div>
      )}>
        <DvdDetailsComponent
          dvd={dvdDetails}
        />
      </Layout>
  ) : <Loader />;
};

export default DvdsDetails;
